/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const trailer = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M6.6 9.642A1.862 1.862 0 0 1 4.733 11.5a1.862 1.862 0 0 1-1.866-1.858m3.733 0a1.862 1.862 0 0 0-1.867-1.858c-1.03 0-1.866.832-1.866 1.858m3.733 0h5.6m-9.333 0c-.719 0-1.867.11-1.867-.929V5.43a.94.94 0 0 1 .933-.929h6.534C10.5 4.5 12.2 6.69 12.2 8.713v.93m0 0H15"
    />
  </svg>
)
export default trailer
